<template>
    <button
        aria-label="скопировать"
        class="relative ml-1 transition-colors duration-150 hover:text-ash-300"
        @click="copyText(textToCopy)">
        <AtomIcon
            name="copy"
            :width="size === 'big' ? 32 : 24"
            :height="size === 'big' ? 32 : 24"
            class="transition-opacity duration-300 ease-in-out" />
        <AtomIcon
            name="success"
            :class="[
                { 'opacity-100': isCopied },
                doneColorAccent ? 'text-accent' : 'text-white',
                size === 'big'
                    ? 'bottom-[5px] right-[3px] size-4'
                    : 'bottom-[5px] right-0 size-3.5',
            ]"
            class="absolute opacity-0 transition-opacity duration-300" />
    </button>
</template>

<script lang="ts" setup>
import { useClipboard } from '@vueuse/core'

import AtomIcon from '~/components/atom/atom-icon/AtomIcon.vue'

const { copy } = useClipboard()

defineProps({
    textToCopy: {
        type: String as PropType<string>,
        required: true,
    },
    size: {
        type: String as PropType<'big' | 'small'>,
        default: 'big',
    },
    doneColorAccent: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
})

const isCopied = ref(false)

function copyText(textToCopy: string) {
    isCopied.value = true

    copy(textToCopy)

    setTimeout(() => {
        isCopied.value = false
    }, 500)
}
</script>
